import React, {FC, SVGProps} from 'react';

//From ic-arbol-bikenta.svg
const Bikenta_RSC: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="23.318 23.422 273.123 96.972"
    height="100%"
    {...props}
  >
    <g fill="#37331F">
      <path d="M110.837 112.022c.42-.803 1.379-1.187 2.219-1.187 1.691 0 2.999 1.079 2.999 3.07 0 1.954-1.307 3.07-3.01 3.07-.875 0-1.739-.384-2.207-1.188l-.048 1.079h-.936v-8.396h.983v3.552zm.049 1.871c0 1.296.923 2.159 2.099 2.159 1.151 0 2.087-.779 2.087-2.146 0-1.392-.936-2.147-2.087-2.147-1.164-.001-2.099.862-2.099 2.134zM118.649 109.144c0 .852-1.295.852-1.295-.012 0-.852 1.295-.852 1.295.012zm-1.151 7.723h.983v-5.949h-.983v5.949zM122.968 110.811c1.811 0 3.083 1.271 3.083 3.106 0 1.799-1.295 3.059-3.083 3.059-1.775 0-3.07-1.26-3.07-3.059 0-1.835 1.308-3.106 3.07-3.106zm.013.899c-1.211 0-2.099.888-2.099 2.207 0 1.247.875 2.135 2.087 2.135 1.224 0 2.099-.888 2.111-2.135-.001-1.319-.912-2.207-2.099-2.207zM132.771 115.92c-.6.707-1.631 1.056-2.555 1.056-1.835 0-3.118-1.212-3.118-3.095 0-1.787 1.283-3.07 3.07-3.07 1.811 0 3.19 1.115 2.962 3.479h-5.038c.108 1.091 1.008 1.774 2.147 1.774.672 0 1.487-.264 1.883-.743l.66.6h-.011zm-.576-2.447c-.048-1.151-.84-1.774-2.003-1.774-1.032 0-1.931.623-2.099 1.763h4.102v.011zM139.431 116.064a3.015 3.015 0 0 1-2.207.912c-1.691 0-3.094-1.092-3.094-3.07 0-1.979 1.379-3.07 3.094-3.07.804 0 1.523.275 2.147.887l-.624.648a2.151 2.151 0 0 0-1.499-.601c-1.175 0-2.123.804-2.123 2.136 0 1.379.959 2.135 2.111 2.135.564 0 1.127-.192 1.547-.624l.66.659-.012-.012zM143.249 110.811c1.811 0 3.083 1.271 3.083 3.106 0 1.799-1.295 3.059-3.083 3.059-1.775 0-3.07-1.26-3.07-3.059-.001-1.835 1.307-3.106 3.07-3.106zm.012.899c-1.211 0-2.099.888-2.099 2.207 0 1.247.875 2.135 2.087 2.135 1.224 0 2.099-.888 2.111-2.135-.001-1.319-.912-2.207-2.099-2.207zM147.75 110.931h.899l.048.947a2.42 2.42 0 0 1 2.027-1.031c1.499 0 2.603 1.007 2.603 2.746v3.274h-.983v-3.262c0-1.14-.672-1.848-1.799-1.848-1.079.012-1.823.863-1.823 1.931v3.179h-.972v-5.936zM157.732 110.811c1.811 0 3.083 1.271 3.083 3.106 0 1.799-1.296 3.059-3.083 3.059-1.775 0-3.07-1.26-3.07-3.059 0-1.835 1.307-3.106 3.07-3.106zm.013.899c-1.211 0-2.099.888-2.099 2.207 0 1.247.875 2.135 2.087 2.135 1.224 0 2.099-.888 2.111-2.135-.001-1.319-.912-2.207-2.099-2.207zM162.246 110.954h.912l.06.864c.359-.696 1.079-.972 1.751-.972.815 0 1.655.348 1.991 1.295.432-.911 1.247-1.295 2.087-1.295 1.559 0 2.494 1.02 2.494 2.639v3.382h-.983v-3.382c0-.972-.563-1.716-1.535-1.716s-1.619.768-1.619 1.739v3.358h-.983v-3.358c0-.972-.611-1.739-1.595-1.739-.972 0-1.607.768-1.607 1.739v3.358h-.983v-5.925l.01.013zM173.862 108.472h1.067v.036l-.828 1.571h-.839v-.061l.6-1.546zm.432 2.554h-1.02v5.841h1.02v-5.841zM180.963 116.892l-.024-1.08c-.467.815-1.367 1.199-2.183 1.199-1.703 0-3.034-1.175-3.034-3.105 0-1.919 1.355-3.07 3.047-3.059.887 0 1.763.407 2.194 1.175l.012-1.079h.96v5.925h-.947l-.025.024zm-2.159-5.11c-1.175 0-2.122.839-2.122 2.158s.947 2.171 2.122 2.171c2.854 0 2.854-4.342.013-4.342l-.013.013zM188.165 119.662h-1.056l1.235-2.879-2.387-5.841h1.115l1.164 3.082.647 1.691.636-1.679 1.307-3.095h1.08l-3.741 8.721zM198.629 119.494c1.019 0 2.086-.372 2.086-1.403 0-.96-.971-1.428-2.074-1.428-1.859 0-3.131-1.079-3.131-2.926 0-1.955 1.607-2.938 3.131-2.938.539 0 1.247.144 1.679.443l.636-.768.695.552-.671.792c.468.527.768 1.055.768 1.919 0 1.007-.516 2.038-1.667 2.41 1.151.336 1.631 1.079 1.631 1.931 0 1.535-1.523 2.315-3.095 2.315-1.787 0-3.07-.936-3.034-2.531h.947c-.001 1.152 1.019 1.62 2.099 1.632zm.023-3.694c1.26 0 2.135-.911 2.135-2.051 0-1.355-1.031-2.051-2.146-2.051-1.056 0-2.159.659-2.159 2.039.024 1.355.983 2.063 2.17 2.063zM208.503 115.92c-.6.707-1.631 1.056-2.555 1.056-1.835 0-3.118-1.212-3.118-3.095 0-1.787 1.283-3.07 3.07-3.07 1.812 0 3.19 1.115 2.963 3.479h-5.038c.108 1.091 1.008 1.774 2.147 1.774.672 0 1.487-.264 1.883-.743l.659.6h-.011zm-.575-2.447c-.048-1.151-.84-1.774-2.003-1.774-1.031 0-1.932.623-2.1 1.763h4.103v.011zM214.036 112.262c-.517-.468-1.056-.576-1.668-.576-.815-.012-1.475.276-1.463.864.012.611.731.791 1.476.875 1.079.132 2.519.348 2.494 1.812-.023 1.188-1.151 1.774-2.482 1.774-.995 0-1.979-.275-2.65-1.115l.563-.684c.527.647 1.379.912 2.111.912.647 0 1.475-.204 1.499-.924.012-.647-.684-.84-1.596-.947-1.139-.145-2.362-.444-2.362-1.703-.012-1.26 1.259-1.751 2.398-1.739.888 0 1.619.216 2.255.792l-.563.647-.012.012zM217.889 110.954h1.835v.84h-1.847v3.13c0 .696.228 1.14.936 1.14.264 0 .563-.084.827-.216l.288.815c-.396.18-.756.276-1.151.288-1.271.024-1.871-.72-1.871-2.027v-3.13h-1.188v-.84h1.188v-1.631l.983-.107v1.738zM222.137 109.144c0 .852-1.295.852-1.295-.012 0-.852 1.295-.852 1.295.012zm-1.152 7.723h.983v-5.949h-.983v5.949zM229.466 113.917c0 1.799-1.259 3.059-3.034 3.059-1.774 0-3.034-1.26-3.034-3.059s1.271-3.082 3.034-3.082c1.764 0 3.047 1.283 3.047 3.082h-.013zm-5.085 0c0 1.247.84 2.135 2.063 2.135 1.223 0 2.062-.888 2.062-2.135s-.876-2.183-2.051-2.183c-1.212 0-2.063.936-2.063 2.183h-.011zm1.499-3.91h.888l1.188-1.499v-.036h-1.199l-.876 1.476v.059zM230.898 110.931h.899l.048.947a2.42 2.42 0 0 1 2.027-1.031c1.499 0 2.603 1.007 2.603 2.746v3.274h-.983v-3.262c0-1.14-.672-1.848-1.8-1.848-1.079.012-1.822.863-1.822 1.931v3.179h-.972v-5.936zM241.709 116.879v-5.001h-1.163v-.863h1.163v-.468c0-1.355.744-2.147 1.991-2.147.479 0 .936.156 1.344.433l-.408.731c-.324-.192-.576-.3-.911-.3-.636 0-1.044.396-1.044 1.283v.468h1.859v.863h-1.859v4.989h-.983l.011.012zM248.188 110.811c1.812 0 3.083 1.271 3.083 3.106 0 1.799-1.296 3.059-3.083 3.059-1.774 0-3.07-1.26-3.07-3.059-.001-1.835 1.307-3.106 3.07-3.106zm.012.899c-1.212 0-2.1.888-2.1 2.207 0 1.247.876 2.135 2.087 2.135 1.224 0 2.1-.888 2.111-2.135.001-1.319-.911-2.207-2.098-2.207zM253.613 110.931l.071.888c.408-.768 1.14-.983 1.823-.983a2.222 2.222 0 0 1 1.379.443l-.443.84a1.703 1.703 0 0 0-1.031-.324c-.948.012-1.739.684-1.739 1.775v3.298h-.983v-5.925h.911l.012-.012zM262.935 115.92c-.6.707-1.631 1.056-2.555 1.056-1.835 0-3.118-1.212-3.118-3.095 0-1.787 1.283-3.07 3.07-3.07 1.812 0 3.19 1.115 2.963 3.479h-5.038c.108 1.091 1.008 1.774 2.147 1.774.672 0 1.487-.264 1.883-.743l.659.6h-.011zm-.576-2.447c-.048-1.151-.84-1.774-2.003-1.774-1.031 0-1.932.623-2.1 1.763h4.103v.011zM268.468 112.262c-.517-.468-1.056-.576-1.668-.576-.815-.012-1.475.276-1.463.864.012.611.731.791 1.476.875 1.079.132 2.519.348 2.494 1.812-.023 1.188-1.151 1.774-2.482 1.774-.995 0-1.979-.275-2.65-1.115l.563-.684c.527.647 1.379.912 2.111.912.647 0 1.475-.204 1.499-.924.012-.647-.684-.84-1.596-.947-1.139-.145-2.362-.444-2.362-1.703-.012-1.26 1.259-1.751 2.398-1.739.888 0 1.619.216 2.255.792l-.563.647-.012.012zM272.32 110.954h1.835v.84h-1.847v3.13c0 .696.228 1.14.936 1.14.264 0 .563-.084.827-.216l.288.815c-.396.18-.756.276-1.151.288-1.271.024-1.871-.72-1.871-2.027v-3.13h-1.188v-.84h1.188v-1.631l.983-.107v1.738zM280.287 116.892l-.024-1.08c-.468.815-1.367 1.199-2.183 1.199-1.703 0-3.034-1.175-3.034-3.105 0-1.919 1.354-3.07 3.046-3.059.888 0 1.763.407 2.195 1.175l.012-1.079h.959v5.925h-.947l-.024.024zm-2.159-5.11c-1.176 0-2.123.839-2.123 2.158s.947 2.171 2.123 2.171c2.854 0 2.854-4.342.012-4.342l-.012.013zM284.117 116.867h-.983v-8.396h.983v8.396z" />
    </g>
    <path
      fill="#37331F"
      d="M108.956 84.778c0-5.263-.001-10.525.001-15.788 0-.976.004-.979.951-.979 2.515-.002 5.03.016 7.544-.012.621-.007.804.215.801.812-.02 3.26-.011 6.52-.007 9.78.001.741.011.743.686.409 6.78-3.355 14.91.569 16.496 8.028.919 4.322.14 8.305-2.932 11.63-2.587 2.799-5.847 3.952-9.635 3.607-1.452-.132-2.834-.529-4.117-1.235-.264-.145-.483-.239-.51.199-.02.336-.241.412-.53.411-2.724-.002-5.449-.008-8.173.006-.554.003-.576-.326-.576-.731.004-2.631.001-5.263.001-7.894v-8.243zm9.289 5.259c0 .978.007 1.956-.004 2.933-.004.35.095.61.383.841 1.651 1.319 4.453 1.435 6.233.237 1.686-1.134 2.408-3.458 1.727-5.611-1.174-3.71-5.687-3.993-8.062-2.085-.25.201-.279.464-.278.751.003.978.002 1.956.001 2.934zM163.214 85.379c.842-.899 1.663-1.77 2.478-2.648 1.283-1.382 2.566-2.764 3.84-4.154.227-.247.489-.329.807-.329 3.097.003 6.194 0 9.291.004.179 0 .414-.055.508.139.118.244-.135.369-.265.512-2.542 2.785-5.08 5.575-7.647 8.338-.351.378-.317.613-.063 1.005a3442.59 3442.59 0 0 1 8.08 12.574c.133.208.417.424.301.667-.142.296-.5.148-.76.149-2.934.01-5.868-.006-8.802.017-.532.004-.85-.177-1.134-.618-1.277-1.974-2.597-3.921-3.873-5.896-.307-.475-.515-.485-.87-.066a40.17 40.17 0 0 1-1.652 1.801c-.261.272-.362.576-.358.946.01 1.001-.027 2.004.012 3.003.026.651-.227.836-.856.829-2.538-.028-5.076-.03-7.614.001-.641.008-.842-.199-.839-.837.023-3.889.011-7.777.011-11.666V67.551c0-1.021.003-1.022 1.048-1.022 2.445-.001 4.89.024 7.335-.015.708-.011.921.212.917.913-.024 5.216-.014 11.912-.009 17.128 0 .248-.067.508.114.824zM285.251 89.979c0 3.584-.014 7.168.013 10.751.005.674-.149.941-.886.929-2.536-.043-5.073-.02-7.609-.013-.451.001-.816.002-.845-.624-.021-.452-.321-.158-.49-.067-1.736.933-3.582 1.457-5.556 1.366-4.594-.212-7.913-2.465-10.019-6.494-2.374-4.54-1.755-10.665 1.921-14.636 2.853-3.082 8.066-4.451 12.003-2.989.588.218 1.191.405 1.733.731.262.158.427.164.443-.209.017-.414.323-.468.644-.468 2.676-.003 5.352.005 8.029-.007.628-.003.645.39.621.84v.07c-.002 3.606-.002 7.213-.002 10.82zm-9.306-.121c0-.976-.01-1.952.005-2.928.006-.386-.138-.654-.436-.891-1.565-1.242-4.285-1.389-5.987-.31-1.696 1.076-2.499 3.366-1.962 5.47 1.026 4.019 5.763 4.234 7.999 2.43.28-.226.388-.493.384-.845-.01-.974-.003-1.95-.003-2.926zM208.302 89.937c0-3.586-.001-7.172.001-10.758 0-.912.016-.928.948-.929 2.445-.003 4.89.007 7.335-.007.599-.003 1.039.041 1.028.836-.008.606.377.204.55.094 1.197-.761 2.487-1.288 3.895-1.45 6.106-.705 10.648 2.696 11.05 8.725.322 4.834.058 9.682.125 14.523.008.588-.292.681-.788.678-2.561-.014-5.123-.03-7.684.009-.707.011-.929-.21-.924-.91.027-3.446.013-6.892.011-10.339 0-.466-.006-.932-.03-1.396-.119-2.277-1.952-3.569-4.145-2.915a5.547 5.547 0 0 0-.896.382c-.832.419-1.235.999-1.217 2.036.071 4.05.03 8.103.028 12.154 0 .969-.005.971-.969.972-2.445.002-4.89.001-7.335 0-.98-.001-.982-.003-.983-1.017V89.937z"
    />
    <path
      fill="#37331F"
      d="M196.577 91.827c-2.514.001-5.028-.002-7.542.002-.742.001-.786.058-.499.754.714 1.732 1.999 2.703 3.882 2.826 1.321.086 2.617.053 3.659-.96.196-.19.484-.137.738-.137 2.374-.002 4.749-.005 7.123.001.841.002.915.097.63.892-1.091 3.044-3.203 5.154-6.212 6.195-5.066 1.752-9.869 1.22-14.135-2.23-1.949-1.576-3.088-3.704-3.648-6.128-.727-3.145-.443-6.208.985-9.112 1.288-2.62 3.335-4.496 6.097-5.438 4.288-1.462 8.498-1.233 12.43 1.141 2.967 1.791 4.465 4.585 4.936 7.964a13.94 13.94 0 0 1 .039 3.547c-.066.566-.304.69-.801.688-2.561-.012-5.121-.006-7.682-.005zm-3.885-4.683c1.21 0 2.422-.024 3.631.01.58.016.675-.19.523-.7-.505-1.691-1.7-2.437-3.384-2.659-2.171-.286-4.159.822-4.862 2.778-.156.433-.089.585.391.577 1.233-.02 2.467-.007 3.701-.006zM243.864 69.335c1.303 0 2.607.018 3.91-.008.545-.011.734.188.728.732-.023 1.932-.009 5.344-.008 7.276.001.909.003.912.942.913 1.862.002 3.724.017 5.586-.007.631-.008.864.222.857.859-.026 2.118-.029 4.236.002 6.354.01.658-.244.834-.864.824-1.908-.03-3.817.009-5.726-.022-.592-.01-.843.139-.809.777.078 1.439-.084 2.884.103 4.323.202 1.552 1.01 2.282 2.582 2.38 1.354.085 2.631-.235 3.898-.644.857-.277.876-.248.969.637.234 2.242.481 4.483.742 6.722.04.343.024.604-.339.727-4.04 1.362-8.101 1.9-12.05-.188-3.158-1.67-4.61-4.54-5.062-7.98-.262-1.993-.107-3.998-.122-5.998-.004-.582-.197-.777-.769-.753-.883.037-1.769-.006-2.653.014-.469.01-.669-.152-.665-.644.016-2.234.018-4.469-.002-6.703-.005-.54.243-.685.72-.677.768.014 1.536.003 2.304.002 1.051-.002 1.052-.002 1.052-1.02.001-1.862.021-5.204-.011-7.066-.011-.638.202-.859.842-.839 1.282.037 2.563.009 3.843.009zM139.582 79.238c.001-.937.05-.986.988-.988 2.491-.003 4.983-.004 7.474.001.843.002.912.069.912.92 0-.216-.043 1.071.014 21.584.002.71-.234.912-.931.902-2.491-.038-4.983-.014-7.474-.015-.977-.001-.983-.003-.983-.96-.002-3.585-.002-17.882 0-21.444z"
    />
    <path
      fill="#80A92C"
      d="M139.582 67.424c.001-.937.05-.986.988-.988 2.491-.003 4.983-.004 7.474.001.843.002.912.069.912.92.003 7.195-.006.084.014 7.279.002.71-.234.912-.931.902-2.491-.038-4.983-.014-7.474-.015-.977-.001-.983-.003-.983-.96-.002-3.586-.002-3.577 0-7.139z"
    />
    <path
      fill="#CECCCC"
      d="M64.298 75.579h3.726v3.726h-3.726zM68.024 75.579h3.726v3.726h-3.726z"
    />
    <path fill="#CECCCC" d="M71.749 75.579h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M75.475 75.579h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M79.2 75.579h3.726v3.726H79.2z" />
    <path fill="#313321" d="M64.298 79.305h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M68.024 79.305h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M71.749 79.305h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M75.475 79.305h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M79.2 79.305h3.726v3.726H79.2z" />
    <path fill="#2E412A" d="M64.298 83.03h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M68.024 83.03h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M71.749 83.03h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M75.475 83.03h3.726v3.726h-3.726z" />
    <path fill="#818070" d="M79.2 83.03h3.726v3.726H79.2z" />
    <path fill="#2E412A" d="M64.298 86.756h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M68.024 86.756h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M71.749 86.756h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M75.475 86.756h3.726v3.726h-3.726z" />
    <path fill="#818070" d="M79.2 86.756h3.726v3.726H79.2z" />
    <path fill="#2E412A" d="M64.298 90.481h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M68.024 90.481h3.726v3.726h-3.726z" />
    <path fill="#2E412A" d="M71.749 90.481h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M75.475 90.481h3.726v3.726h-3.726z" />
    <path fill="#6B6963" d="M79.2 90.481h3.726v3.726H79.2z" />
    <path fill="#2E412A" d="M64.298 94.207h3.726v3.726h-3.726z" />
    <path fill="#37331F" d="M68.024 94.207h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 94.207h3.726v3.726h-3.726zM75.475 94.207h3.726v3.726h-3.726z"
    />
    <path fill="#6B6963" d="M79.2 94.207h3.726v3.726H79.2z" />
    <path fill="#80A92C" d="M53.122 97.932h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M56.847 97.932h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 97.932h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M64.298 97.932h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M68.024 97.932h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M71.749 97.932h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M75.475 97.932h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M79.2 97.932h3.726v3.726H79.2z" />
    <path fill="#81BA27" d="M82.926 97.932h3.726v3.726h-3.726z" />
    <path fill="#A7C56C" d="M86.651 97.932h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M90.377 97.932h3.726v3.726h-3.726z" />
    <path fill="#E5EFCF" d="M94.102 97.932h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M97.828 97.932h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M101.553 97.932h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M105.279 97.932h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M75.475 23.422h3.726v3.726h-3.726zM86.651 23.422h3.726v3.726h-3.726zM97.828 23.422h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M79.2 27.147h3.726v3.726H79.2zM82.926 27.147h3.726v3.726h-3.726zM90.377 27.147h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M94.102 27.147h3.726v3.726h-3.726zM68.024 30.873h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M75.475 30.873h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M79.2 30.873h3.726v3.726H79.2zM86.651 30.873h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M90.377 30.873h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M101.553 30.873h3.726v3.726h-3.726zM105.279 30.873h3.726v3.726h-3.726zM64.298 34.598h3.726v3.726h-3.726zM68.024 34.598h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M75.475 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M82.926 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M86.651 34.598h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M94.102 34.598h3.726v3.726h-3.726zM97.828 34.598h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M71.749 38.324h3.726v3.726h-3.726zM75.475 38.324h3.726v3.726h-3.726zM86.651 38.324h3.726v3.726h-3.726zM90.377 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M94.102 38.324h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M101.553 38.324h3.726v3.726h-3.726zM105.279 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M60.573 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M64.298 42.049h3.726v3.726h-3.726zM68.024 42.049h3.726v3.726h-3.726zM75.475 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M79.2 42.049h3.726v3.726H79.2z" />
    <path fill="#80A92C" d="M86.651 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M90.377 42.049h3.726v3.726h-3.726zM97.828 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M109.004 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M60.573 45.775h3.726v3.726h-3.726zM68.024 45.775h3.726v3.726h-3.726zM79.2 45.775h3.726v3.726H79.2z"
    />
    <path fill="#81BA27" d="M82.926 45.775h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M86.651 45.775h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M94.102 45.775h3.726v3.726h-3.726zM97.828 45.775h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M101.553 45.775h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M112.73 45.775h3.726v3.726h-3.726zM60.573 49.5h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M68.024 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M71.749 49.5h3.726v3.726h-3.726zM79.2 49.5h3.726v3.726H79.2z"
    />
    <path fill="#0E7641" d="M82.926 49.5h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M86.651 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M90.377 49.5h3.726v3.726h-3.726zM105.279 49.5h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M109.004 49.5h3.726v3.726h-3.726zM60.573 53.226h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M64.298 53.226h3.726v3.726h-3.726zM75.475 53.226h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M82.926 53.226h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M86.651 53.226h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M94.102 53.226h3.726v3.726h-3.726zM101.553 53.226h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M109.004 53.226h3.726v3.726h-3.726zM64.298 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M68.024 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M71.749 56.952h3.726v3.726h-3.726zM79.2 56.952h3.726v3.726H79.2z"
    />
    <path fill="#0E7641" d="M82.926 56.952h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M86.651 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M90.377 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M94.102 56.952h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M97.828 56.952h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M101.553 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M64.298 60.677h3.726v3.726h-3.726zM71.749 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M75.475 60.677h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M82.926 60.677h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M86.651 60.677h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M94.102 60.677h3.726v3.726h-3.726zM97.828 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M60.573 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M68.024 64.403h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M82.926 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M86.651 64.403h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M90.377 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M101.553 64.403h3.726v3.726h-3.726zM105.279 64.403h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M82.926 68.128h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M86.651 68.128h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M94.102 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M79.2 71.854h3.726v3.726H79.2zM82.926 71.854h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M86.651 71.854h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M94.102 71.854h3.726v3.726h-3.726zM97.828 71.854h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M82.926 75.579h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M86.651 75.579h3.726v3.726h-3.726zM53.122 23.422h3.726v3.726h-3.726zM64.298 23.422h3.726v3.726h-3.726zM75.475 23.422h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M56.847 27.147h3.726v3.726h-3.726zM60.573 27.147h3.726v3.726h-3.726zM68.024 27.147h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M71.749 27.147h3.726v3.726h-3.726zM45.671 30.873h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M53.122 30.873h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M56.847 30.873h3.726v3.726h-3.726zM64.298 30.873h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M68.024 30.873h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M79.2 30.873h3.726v3.726H79.2zM82.926 30.873h3.726v3.726h-3.726zM41.945 34.598h3.726v3.726h-3.726zM45.671 34.598h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M53.122 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M60.573 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M64.298 34.598h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M71.749 34.598h3.726v3.726h-3.726zM75.475 34.598h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M49.396 38.324h3.726v3.726h-3.726zM53.122 38.324h3.726v3.726h-3.726zM64.298 38.324h3.726v3.726h-3.726zM68.024 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M71.749 38.324h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M79.2 38.324h3.726v3.726H79.2zM82.926 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M38.22 42.049h3.726v3.726H38.22z" />
    <path
      fill="#81BA27"
      d="M41.945 42.049h3.726v3.726h-3.726zM45.671 42.049h3.726v3.726h-3.726zM53.122 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M56.847 42.049h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M64.298 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M68.024 42.049h3.726v3.726h-3.726zM75.475 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M86.651 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M38.22 45.775h3.726v3.726H38.22zM45.671 45.775h3.726v3.726h-3.726zM56.847 45.775h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M60.573 45.775h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M64.298 45.775h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 45.775h3.726v3.726h-3.726zM75.475 45.775h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M79.2 45.775h3.726v3.726H79.2z" />
    <path
      fill="#81BA27"
      d="M90.377 45.775h3.726v3.726h-3.726zM38.22 49.5h3.726v3.726H38.22z"
    />
    <path fill="#80A92C" d="M45.671 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M49.396 49.5h3.726v3.726h-3.726zM56.847 49.5h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M60.573 49.5h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M64.298 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M68.024 49.5h3.726v3.726h-3.726zM82.926 49.5h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M86.651 49.5h3.726v3.726h-3.726zM38.22 53.226h3.726v3.726H38.22z"
    />
    <path
      fill="#81BA27"
      d="M41.945 53.226h3.726v3.726h-3.726zM53.122 53.226h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M60.573 53.226h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M64.298 53.226h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 53.226h3.726v3.726h-3.726zM79.2 53.226h3.726v3.726H79.2z"
    />
    <path
      fill="#80A92C"
      d="M86.651 53.226h3.726v3.726h-3.726zM41.945 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M45.671 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M49.396 56.952h3.726v3.726h-3.726zM56.847 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M60.573 56.952h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M64.298 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M68.024 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M71.749 56.952h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M75.475 56.952h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M79.2 56.952h3.726v3.726H79.2z" />
    <path
      fill="#80A92C"
      d="M41.945 60.677h3.726v3.726h-3.726zM49.396 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M53.122 60.677h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 60.677h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M64.298 60.677h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 60.677h3.726v3.726h-3.726zM75.475 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M38.22 64.403h3.726v3.726H38.22z" />
    <path fill="#81BA27" d="M45.671 64.403h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M60.573 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M64.298 64.403h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M68.024 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M79.2 64.403h3.726v3.726H79.2zM82.926 64.403h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M60.573 68.128h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M64.298 68.128h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M71.749 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M56.847 71.854h3.726v3.726h-3.726zM60.573 71.854h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M64.298 71.854h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 71.854h3.726v3.726h-3.726zM75.475 71.854h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M60.573 75.579h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M64.298 75.579h3.726v3.726h-3.726zM94.102 75.579h3.726v3.726h-3.726zM82.926 75.579h3.726v3.726h-3.726zM71.749 75.579h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M90.377 71.854h3.726v3.726h-3.726zM86.651 71.854h3.726v3.726h-3.726zM79.2 71.854h3.726v3.726H79.2z"
    />
    <path
      fill="#81BA27"
      d="M75.475 71.854h3.726v3.726h-3.726zM101.553 68.128h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M94.102 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M90.377 68.128h3.726v3.726h-3.726zM82.926 68.128h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M79.2 68.128h3.726v3.726H79.2z" />
    <path
      fill="#81BA27"
      d="M68.024 68.128h3.726v3.726h-3.726zM64.298 68.128h3.726v3.726h-3.726zM105.279 64.403h3.726v3.726h-3.726zM105.279 60.677h3.726v3.726h-3.726zM101.553 64.403h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M94.102 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M86.651 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M82.926 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M75.475 64.403h3.726v3.726h-3.726zM71.749 64.403h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M97.828 60.677h3.726v3.726h-3.726zM94.102 60.677h3.726v3.726h-3.726zM82.926 60.677h3.726v3.726h-3.726zM79.2 60.677h3.726v3.726H79.2z"
    />
    <path fill="#0E7641" d="M75.475 60.677h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M68.024 60.677h3.726v3.726h-3.726zM64.298 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M109.004 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M105.279 56.952h3.726v3.726h-3.726zM101.553 56.952h3.726v3.726h-3.726zM94.102 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M90.377 56.952h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M82.926 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M79.2 56.952h3.726v3.726H79.2zM71.749 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M60.573 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M109.004 53.226h3.726v3.726h-3.726zM101.553 53.226h3.726v3.726h-3.726zM90.377 53.226h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M86.651 53.226h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M82.926 53.226h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M75.475 53.226h3.726v3.726h-3.726zM71.749 53.226h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M68.024 53.226h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M56.847 53.226h3.726v3.726h-3.726zM109.004 49.5h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M101.553 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M97.828 49.5h3.726v3.726h-3.726zM90.377 49.5h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M86.651 49.5h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M82.926 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M79.2 49.5h3.726v3.726H79.2zM64.298 49.5h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M60.573 49.5h3.726v3.726h-3.726zM109.004 45.775h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M105.279 45.775h3.726v3.726h-3.726zM94.102 45.775h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M86.651 45.775h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M82.926 45.775h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M75.475 45.775h3.726v3.726h-3.726zM68.024 45.775h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M60.573 45.775h3.726v3.726h-3.726zM105.279 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M101.553 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M97.828 42.049h3.726v3.726h-3.726zM90.377 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M86.651 42.049h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M82.926 42.049h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M79.2 42.049h3.726v3.726H79.2z" />
    <path fill="#81BA27" d="M75.475 42.049h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M71.749 42.049h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M68.024 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M105.279 38.324h3.726v3.726h-3.726zM97.828 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M94.102 38.324h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M86.651 38.324h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M82.926 38.324h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M75.475 38.324h3.726v3.726h-3.726zM71.749 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M109.004 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M101.553 34.598h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M86.651 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M82.926 34.598h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M79.2 34.598h3.726v3.726H79.2z" />
    <path
      fill="#80A92C"
      d="M68.024 34.598h3.726v3.726h-3.726zM64.298 34.598h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M86.651 30.873h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M82.926 30.873h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M75.475 30.873h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M90.377 27.147h3.726v3.726h-3.726zM86.651 27.147h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M82.926 27.147h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M75.475 27.147h3.726v3.726h-3.726zM71.749 27.147h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M86.651 23.422h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M82.926 23.422h3.726v3.726h-3.726zM71.749 75.579h3.726v3.726h-3.726zM60.573 75.579h3.726v3.726h-3.726zM49.396 75.579h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M68.024 71.854h3.726v3.726h-3.726zM64.298 71.854h3.726v3.726h-3.726zM56.847 71.854h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M53.122 71.854h3.726v3.726h-3.726zM79.2 68.128h3.726v3.726H79.2z"
    />
    <path fill="#80A92C" d="M71.749 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M68.024 68.128h3.726v3.726h-3.726zM60.573 68.128h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M56.847 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M45.671 68.128h3.726v3.726h-3.726zM41.945 68.128h3.726v3.726h-3.726zM82.926 64.403h3.726v3.726h-3.726zM79.2 64.403h3.726v3.726H79.2z"
    />
    <path fill="#80A92C" d="M71.749 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M64.298 64.403h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M60.573 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M53.122 64.403h3.726v3.726h-3.726zM49.396 64.403h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M75.475 60.677h3.726v3.726h-3.726zM71.749 60.677h3.726v3.726h-3.726zM60.573 60.677h3.726v3.726h-3.726zM56.847 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M53.122 60.677h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M45.671 60.677h3.726v3.726h-3.726zM41.945 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M86.651 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M82.926 56.952h3.726v3.726h-3.726zM79.2 56.952h3.726v3.726H79.2zM71.749 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M68.024 56.952h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M56.847 56.952h3.726v3.726h-3.726zM49.396 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M38.22 56.952h3.726v3.726H38.22z" />
    <path
      fill="#80A92C"
      d="M86.651 53.226h3.726v3.726h-3.726zM79.2 53.226h3.726v3.726H79.2zM68.024 53.226h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M64.298 53.226h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M60.573 53.226h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M53.122 53.226h3.726v3.726h-3.726zM49.396 53.226h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M45.671 53.226h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M34.494 53.226h3.726v3.726h-3.726z" />
    <path fill="#A7C56C" d="M86.651 49.5h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M79.2 49.5h3.726v3.726H79.2z" />
    <path
      fill="#81BA27"
      d="M75.475 49.5h3.726v3.726h-3.726zM68.024 49.5h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M64.298 49.5h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 49.5h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M56.847 49.5h3.726v3.726h-3.726zM41.945 49.5h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M38.22 49.5h3.726v3.726H38.22zM86.651 45.775h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M82.926 45.775h3.726v3.726h-3.726zM71.749 45.775h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M64.298 45.775h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M60.573 45.775h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M53.122 45.775h3.726v3.726h-3.726zM45.671 45.775h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M38.22 45.775h3.726v3.726H38.22zM82.926 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M79.2 42.049h3.726v3.726H79.2z" />
    <path
      fill="#81BA27"
      d="M75.475 42.049h3.726v3.726h-3.726zM68.024 42.049h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M64.298 42.049h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 42.049h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M56.847 42.049h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M53.122 42.049h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M49.396 42.049h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M45.671 42.049h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M82.926 38.324h3.726v3.726h-3.726zM75.475 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M71.749 38.324h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M64.298 38.324h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M60.573 38.324h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M53.122 38.324h3.726v3.726h-3.726zM49.396 38.324h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M86.651 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M79.2 34.598h3.726v3.726H79.2z" />
    <path fill="#0E7641" d="M64.298 34.598h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M60.573 34.598h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M56.847 34.598h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M45.671 34.598h3.726v3.726h-3.726zM41.945 34.598h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M64.298 30.873h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M60.573 30.873h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M53.122 30.873h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M68.024 27.147h3.726v3.726h-3.726z" />
    <path fill="#A7C56C" d="M64.298 27.147h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M60.573 27.147h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M53.122 27.147h3.726v3.726h-3.726zM49.396 27.147h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M64.298 23.422h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M60.573 23.422h3.726v3.726h-3.726zM34.494 49.5h3.726v3.726h-3.726zM45.671 49.5h3.726v3.726h-3.726zM56.847 49.5h3.726v3.726h-3.726zM38.22 53.226h3.726v3.726H38.22z"
    />
    <path
      fill="#81BA27"
      d="M41.945 53.226h3.726v3.726h-3.726zM49.396 53.226h3.726v3.726h-3.726zM53.122 53.226h3.726v3.726h-3.726zM27.043 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M34.494 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M38.22 56.952h3.726v3.726H38.22zM45.671 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M49.396 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M60.573 56.952h3.726v3.726h-3.726z" />
    <path fill="#A7C56C" d="M64.298 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M23.318 60.677h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M27.043 60.677h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M34.494 60.677h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M41.945 60.677h3.726v3.726h-3.726zM45.671 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M53.122 60.677h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M56.847 60.677h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M30.769 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M34.494 64.403h3.726v3.726h-3.726zM45.671 64.403h3.726v3.726h-3.726zM41.945 64.403h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M49.396 64.403h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M53.122 64.403h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 64.403h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M64.298 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M34.494 68.128h3.726v3.726h-3.726zM38.22 68.128h3.726v3.726H38.22z"
    />
    <path fill="#80A92C" d="M45.671 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M49.396 68.128h3.726v3.726h-3.726zM56.847 68.128h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M68.024 68.128h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M38.22 71.854h3.726v3.726H38.22z" />
    <path fill="#81BA27" d="M41.945 71.854h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M45.671 71.854h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M53.122 71.854h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M56.847 71.854h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M60.573 71.854h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M71.749 71.854h3.726v3.726h-3.726zM30.769 75.579h3.726v3.726h-3.726zM38.22 75.579h3.726v3.726H38.22z"
    />
    <path fill="#0E7641" d="M41.945 75.579h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M45.671 75.579h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M49.396 75.579h3.726v3.726h-3.726zM64.298 75.579h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M68.024 75.579h3.726v3.726h-3.726zM41.945 79.305h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M45.671 79.305h3.726v3.726h-3.726zM38.22 83.03h3.726v3.726H38.22z"
    />
    <path fill="#0E7641" d="M41.945 83.03h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M45.671 83.03h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M49.396 83.03h3.726v3.726h-3.726zM56.847 49.5h3.726v3.726h-3.726zM68.024 49.5h3.726v3.726h-3.726zM79.2 49.5h3.726v3.726H79.2zM60.573 53.226h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M64.298 53.226h3.726v3.726h-3.726zM71.749 53.226h3.726v3.726h-3.726zM75.475 53.226h3.726v3.726h-3.726zM49.396 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M56.847 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M60.573 56.952h3.726v3.726h-3.726zM68.024 56.952h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M71.749 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M82.926 56.952h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M86.651 56.952h3.726v3.726h-3.726z" />
    <path
      fill="#E5EFCF"
      d="M45.671 60.677h3.726v3.726h-3.726zM97.828 64.403h3.726v3.726h-3.726zM53.122 56.952h3.726v3.726h-3.726zM53.122 49.5h3.726v3.726h-3.726zM49.396 45.775h3.726v3.726h-3.726zM41.945 45.775h3.726v3.726h-3.726zM56.847 38.324h3.726v3.726h-3.726zM71.749 30.873h3.726v3.726h-3.726zM94.102 42.049h3.726v3.726h-3.726zM94.102 30.873h3.726v3.726h-3.726zM94.102 49.5h3.726v3.726h-3.726zM97.828 53.226h3.726v3.726h-3.726zM90.377 60.677h3.726v3.726h-3.726zM75.475 68.128h3.726v3.726h-3.726zM105.279 53.226h3.726v3.726h-3.726zM53.122 68.128h3.726v3.726h-3.726zM56.847 75.579h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M49.396 60.677h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M56.847 60.677h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M64.298 60.677h3.726v3.726h-3.726zM68.024 60.677h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M75.475 60.677h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M79.2 60.677h3.726v3.726H79.2z" />
    <path fill="#81BA27" d="M53.122 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M56.847 64.403h3.726v3.726h-3.726zM68.024 64.403h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M71.749 64.403h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M75.475 64.403h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M82.926 64.403h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M86.651 64.403h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M41.945 68.128h3.726v3.726h-3.726zM45.671 68.128h3.726v3.726h-3.726z"
    />
    <path
      fill="#81BA27"
      d="M49.396 68.128h3.726v3.726h-3.726zM56.847 68.128h3.726v3.726h-3.726zM60.573 68.128h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M68.024 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 68.128h3.726v3.726h-3.726zM79.2 68.128h3.726v3.726H79.2z"
    />
    <path fill="#81BA27" d="M90.377 68.128h3.726v3.726h-3.726z" />
    <path
      fill="#80A92C"
      d="M41.945 71.854h3.726v3.726h-3.726zM49.396 71.854h3.726v3.726h-3.726zM60.573 71.854h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M64.298 71.854h3.726v3.726h-3.726z" />
    <path fill="#36481D" d="M68.024 71.854h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M75.475 71.854h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M79.2 71.854h3.726v3.726H79.2z" />
    <path fill="#80A92C" d="M82.926 71.854h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M94.102 71.854h3.726v3.726h-3.726zM41.945 75.579h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M49.396 75.579h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M53.122 75.579h3.726v3.726h-3.726zM60.573 75.579h3.726v3.726h-3.726z"
    />
    <path fill="#0E7641" d="M64.298 75.579h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M68.024 75.579h3.726v3.726h-3.726z" />
    <path
      fill="#0E7641"
      d="M71.749 75.579h3.726v3.726h-3.726zM86.651 75.579h3.726v3.726h-3.726z"
    />
    <path
      fill="#80A92C"
      d="M90.377 75.579h3.726v3.726h-3.726zM41.945 79.305h3.726v3.726h-3.726z"
    />
    <path fill="#81BA27" d="M45.671 79.305h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M45.671 83.03h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M49.396 83.03h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M97.828 79.305h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M101.553 79.305h3.726v3.726h-3.726zM105.279 75.579h3.726v3.726h-3.726z"
    />
    <path
      fill="#0E7641"
      d="M105.279 71.854h3.726v3.726h-3.726zM109.004 68.128h3.726v3.726h-3.726zM116.819 72.217h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M101.553 83.03h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M97.828 79.305h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M101.553 79.305h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M105.279 79.305h3.726v3.726h-3.726z" />
    <path
      fill="#81BA27"
      d="M101.553 75.579h3.726v3.726h-3.726zM109.004 75.579h3.726v3.726h-3.726zM281.539 89.471h3.726v3.726h-3.726zM288.99 82.02h3.726v3.726h-3.726z"
    />
    <path fill="#80A92C" d="M281.539 82.02h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M292.715 78.294h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M288.99 78.294h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M281.539 78.294h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M274.088 78.294h3.726v3.726h-3.726z" />
    <path fill="#81BA27" d="M274.088 78.294h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M277.813 78.294h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M288.99 78.294h3.726v3.726h-3.726z" />
    <path fill="#80A92C" d="M292.715 78.294h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M281.539 82.02h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M281.539 85.745h3.726v3.726h-3.726z" />
    <path fill="#0E7641" d="M285.264 85.745h3.726v3.726h-3.726z" />
  </svg>
);

export default Bikenta_RSC;
